import React, { useState, useEffect, useRef } from "react";
import "./NutritionFeedback.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import FeedbackItem from "../../Components/FeedbackItem/FeedbackItem";
import feelings from "./feelings";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import useWeeklyDietPlans from "../../Hooks/useWeeklyDietPlans";
import Alert from "../../Components/Alert/Alert";
import SlideRuler from "slide-ruler";
import WeightChange from "../../Components/WeightChange/WeightChange";
import { useBaseUrl } from "../../ApiContext";

export default function NutritionFeedback() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const { weeklyDietReports, setWeeklyDietReports } =
    useWeeklyDietPlans(userToken);
  const slideRulerRef = useRef(null);
  const [selectedWeight, setSelectedWeight] = useState(50);
  const compliancePercent = ["20", "50", "75", "100"];
  const [selectedPercent, setSelectedPercent] = useState(null);
  const [selectedFeeling, setSelectedFeeling] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [selectedWeightLoss, setSelectedWeightLoss] = useState("0.0");
  const [selectedWeekId, setSelectedWeekId] = useState(null);
  const [selectedWeekIndex, setSelectedWeekIndex] = useState(null);
  const [date, setDate] = useState("");

  const handleWeekClick = async (week, index) => {
    setSelectedWeekIndex(index);
    setSelectedWeekId(week.id);
    setDate(week.date.full_date);
    try {
      const response = await Axios.get(
        `${baseUrl}/report/diet_plan/weekly/${week.id}/${week.date.full_date}`,
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      setSelectedWeight(response.data.weight);
      setSelectedWeightLoss(response.data.weight_loss);
      setSelectedFeeling(response.data.feelings_about_week);
      setSelectedPercent(response.data.week_percent);
    } catch (error) {
      console.log("Error during getting week's diet data", error);
      setSelectedWeight(50);
      setSelectedWeightLoss("0.0");
      setSelectedFeeling(null);
      setSelectedPercent(null);
    }
  };

  const handleSizeChange = (label, k, gr) => {
    setSelectedWeightLoss(`${k}.${gr}`);
  };

  const handleCompliancePercent = (option) => {
    setSelectedPercent(option);
  };

  const handleFeeling = (feelingLabel) => {
    setSelectedFeeling(feelingLabel);
  };

  const fetchWeeklyPlans = async () => {
    try {
      const response = await Axios.get(`${baseUrl}/report/diet_plan/weekly`, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      setWeeklyDietReports(response.data.reports);
    } catch (error) {
      console.log("Error during current weekly reports request", error);
    }
  };

  const handleSendReport = () => {
    const fetchSend = async () => {
      const postData = {
        feelings_about_week: selectedFeeling,
        week_percent: selectedPercent,
        weight: selectedWeight,
        weight_loss: selectedWeightLoss,
      };
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("در حال ثبت گزارش...");
      try {
        const response = await Axios.post(
          `${baseUrl}/report/diet_plan/weekly/${selectedWeekId}/${date}`,
          postData,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        console.log(response.data);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("گزارش ثبت شد");
        fetchWeeklyPlans();
      } catch (error) {
        console.log("Error during submiting session data", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    };
    if (selectedWeekId && selectedFeeling && selectedPercent) {
      fetchSend();
    }
    if (!selectedWeekId || !selectedFeeling || !selectedPercent) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }

    if (!selectedWeekId) {
      setAlertText("لطفا هفته مورد نظر خود را انتخاب کنید");
    } else if (!selectedFeeling) {
      setAlertText("لطفا نظر خود را بنویسید");
    } else if (!selectedPercent) {
      setAlertText("لطفا احساس خود نسبت به رژیم را تعیین کنید ");
    }
  };

  useEffect(() => {
    const handleValue = (value) => {
      setSelectedWeight(value);
    };

    if (slideRulerRef.current) {
      slideRulerRef.current.innerHTML = '';
  
      new SlideRuler({
        el: slideRulerRef.current,
        maxValue: 150,
        heightDigit: 35,
        heightDecimal: 55,
        minValue: 0,
        currentValue: selectedWeight,
        lineWidth: 2,
        colorDecimal: "#fff",
        colorDigit: "#fff",
        fontColor: "#fff",
        divide: 15,
        fontMarginTop: 62,
        handleValue: handleValue,
      });
    }
  }, [selectedWeight]);

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay nutritionWrapper">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex nutritionHeader">
            <BackBtn />
          </div>
          <h3 className="pageTitle horizontalBorder nutritionTitle">
            بازخورد هفتگی تغذیه
            <img
              src="/images/fork&Knife.png"
              alt="fork&knife"
              className="nutritionHeaderIcon"
            />
          </h3>
          <div className="nutritionFeedback scroll">
            <div className="feedbackItems horizontalBorder">
              {weeklyDietReports &&
                weeklyDietReports.length > 0 &&
                weeklyDietReports.map((week, index) => (
                  <FeedbackItem
                    key={index}
                    {...week}
                    index={index}
                    label="هفته"
                    onItemClick={() => handleWeekClick(week, index)}
                    selectedItemIndex={selectedWeekIndex}
                  />
                ))}
            </div>
            <div className="nutritionWeightWrapper horizontalBorder">
              <h3>وزن</h3>
              <div className="rulerSelector centeredFlex">
                {selectedWeight !== null && (
                  <div className="rulerValueWrapper centeredFlex">
                    <span className="rulerValue">{selectedWeight}</span>
                    <span className="rulerUnit">kg</span>
                  </div>
                )}
                <div ref={slideRulerRef}></div>
              </div>
            </div>
            <div className="nutritionWeightChange horizontalBorder">
              <h3>در این هفته چند گرم تغییرات وزن داشتید؟</h3>
              <WeightChange
                label="nutritionFeedback"
                onSizeChange={(label, cm, mm) =>
                  handleSizeChange("nutritionFeedback", cm, mm)
                }
                kgFromParent={selectedWeightLoss.split(".")[0]}
                grFromParent={selectedWeightLoss.split(".")[1]}
              />
              <div className="selectedWeightChange centeredFlex">
                <span className="selectedWeightChangeTitle">
                  تغییر وزن هفته:{" "}
                </span>
                <div className="selectedWeightChangeValues centeredFlex">
                  <div className="selectedKilogramChange centeredFlex">
                    <span className="selectedKilogramChangeVal">
                      {selectedWeightLoss.split(".")[0]}
                    </span>
                    <span className="selectedKilogramChangeUnit">K</span>
                  </div>
                  <div className="selectedGramChange centeredFlex">
                    <span className="selectedGramChangeVal">
                      {selectedWeightLoss.split(".")[1]}
                    </span>
                    <span className="selectedGramChangeUnit">gr</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="weekDietCompliance horizontalBorder">
              <h3>در این هفته چند درصد رژیم خود را رعایت کرده اید؟</h3>
              <div className="complianceOptions centeredFlex">
                {compliancePercent.map((option) => (
                  <label
                    key={option}
                    className="classConductionOption centeredFlex"
                  >
                    <span>% {option}</span>
                    <input
                      type="checkbox"
                      className="radioBtn"
                      checked={option === selectedPercent ? true : false}
                      onChange={() => handleCompliancePercent(option)}
                    />
                    <span className="feedbackCustomRadioBtn"></span>
                  </label>
                ))}
              </div>
            </div>
            <div className="weekDietFeeling horizontalBorder">
              <h3>در طول هفته نسبت به رژیم غذایی خود چه احساسی داشتید؟</h3>
              <div className="dietFeelingsOptions">
                {feelings.map((option) => (
                  <label
                    key={option.id}
                    className="classConductionOption centeredFlex"
                  >
                    <span>{option.title}</span>
                    <input
                      type="checkbox"
                      className="radioBtn"
                      checked={option.label === selectedFeeling ? true : false}
                      onChange={() => handleFeeling(option.label)}
                    />
                    <span className="feedbackCustomRadioBtn"></span>
                  </label>
                ))}
              </div>
            </div>
            <button className="nextQuestion" onClick={handleSendReport}>
              ارسال
            </button>
          </div>
          <Alert alertText={alertText} showAlert={showAlert} />
        </div>
      </div>
    </div>
  );
}
